import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';

@Component({
  selector: 'app-user-preferences',
  templateUrl: './user-preferences.component.html',
  styleUrls: ['./user-preferences.component.scss'],
})
export class UserPreferencesComponent implements OnInit {
  preferencesForm!: FormGroup;

  constructor(
    private _globalService: GlobalService,
    private _fb: FormBuilder,
    private _router: Router
  ) {}

  ngOnInit() {
    this.preferencesForm = this._fb.group({
      interests: this._fb.group({
        Spiritual: [false],
        Heritage: [false],
        Nature: [false],
        MedicalAndWellness: [false],
        Crafts: [false],
        Waterfalls: [false],
        Buddhist: [false],
        Sports: [false],
        Knowledge: [false],
      }),
      accessibility: this._fb.group({
        WheelchairFriendly: [false],
        LowWalking: [false],
        SeniorFriendly: [false],
      }),
      foodPreference: this._fb.group({
        VegOnly: [false],
        VegNonVeg: [false],
        Vegan: [false],
      }),
      comfortPreference: this._fb.group({
        AvoidHeat: [false],
        Comfortable: [false],
        Any: [false],
      }),
    });

    const savedPreferences = this._globalService.getUserPreferences();
    if (savedPreferences) {
      this.preferencesForm.patchValue({
        interests: this.arrayToGroupValue(savedPreferences.interests, this.preferencesForm.get('interests')!.value),
        accessibility: this.arrayToGroupValue(savedPreferences.accessibility, this.preferencesForm.get('accessibility')!.value),
        foodPreference: this.arrayToGroupValue(savedPreferences.foodPreference, this.preferencesForm.get('foodPreference')!.value),
        comfortPreference: this.arrayToGroupValue(savedPreferences.comfortPreference, this.preferencesForm.get('comfortPreference')!.value),
      });
    }
  }

  private arrayToGroupValue(selectedKeys: string[], groupValue: { [key: string]: boolean }): { [key: string]: boolean } {
    const result: { [key: string]: boolean } = {};
    Object.keys(groupValue).forEach((key) => {
      result[key] = selectedKeys.includes(key);
    }); 
    return result;
  }

  private getSelectedKeys(groupValue: { [key: string]: boolean }): string[] {
    return Object.keys(groupValue).filter((key) => groupValue[key]);
  }

  onSubmit() {
    // if (!this.preferencesForm.valid) {
    //   // If you add validators later, handle errors here
    //   return;
    // }

    const rawValue = this.preferencesForm.value;    

    const data = {
      interests: this.getSelectedKeys(rawValue.interests),
      accessibility: this.getSelectedKeys(rawValue.accessibility),
      foodPreference: this.getSelectedKeys(rawValue.foodPreference),
      comfortPreference: this.getSelectedKeys(rawValue.comfortPreference),
    };

    // data is a JSON-serializable object of string arrays
    // e.g.
    // {
    //   interests: ['Spiritual', 'Nature'],
    //   accessibility: ['WheelchairFriendly'],
    //   foodPreference: ['VegOnly'],
    //   comfortPreference: ['AvoidHeat']
    // }

    console.log(data);
    
    this._globalService.setUserPreferences(data);
    this._router.navigate(['/tg-itinerary-form']);
  }
}
